module.exports = __webpack_public_path__ + "static/media/experiment-1.e3d55883.PNG";